import { render } from "./DrugstoresListImportWrapper.vue?vue&type=template&id=0527d323"
import script from "./DrugstoresListImportWrapper.vue?vue&type=script&lang=js"
export * from "./DrugstoresListImportWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__